/**
 * 业务类型
 */
export const enum BusinessType {
    all,
    ugc,
    pgc,
}

/**
 * Class Prefix Name
 */
export const K_PLAYER_PREFIX = 'bilibili-player';

/**
 * Storage Keys
 */
export const K_PLAYER_SETTINGS = 'bilibili_player_settings';
